import React, { PureComponent } from 'react';
import { withRouter } from '../../utils/NavigationWrapper';
import PropTypes from 'prop-types';

import {
  Menu as MenuIcon,
  Dashboard as DashboardIcon,
  Build as BuildIcon,
  PermContactCalendar as PermContactIcon,
  Person as PersonIcon,
  Map as MapIcon,
  Settings as SettingsIcon,
  Fingerprint as FingerprintIcon,
  Notifications as NotificationsIcon,
  CheckBox as CheckBoxIcon,
  FolderOpen as FolderIcon,
  ExpandLess,
  ExpandMore,
  ScatterPlot as FleetIcon,
  CloudDownload as UpdateManagementIcon,
  Work as UpdatePackageIcon,
  PlayCircleFilled as UpdateJobIcon,
  CreditCard as BillingIcon,
} from '@mui/icons-material';

import {
  IconButton,
  Drawer,
  MenuItem,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Collapse,
} from '@mui/material';

import PermissionsCheck from '../PermissionsCheck/PermissionsCheck';
import PermissionsEnum from '../../constants/PermissionsEnum';

class AppMenu extends PureComponent {
  render() {
    return (
      <div>
        <IconButton onClick={this.props.onToggleMenu} data-qa="qa-menu" size="large">
          <MenuIcon />
        </IconButton>
        <Drawer width={250} open={this.props.open} onClose={this.props.onToggleMenu}>
          <List width={250}>
            <MenuItem
              onClick={() => {
                this.props.onClickMenuItem(() => this.props.navigate('/'));
              }}
              data-qa="qa-dashboard-button"
            >
              <ListItemIcon>
                <DashboardIcon />
              </ListItemIcon>
              <ListItemText> Dashboard </ListItemText>
            </MenuItem>
            <Divider />
            <PermissionsCheck permission={PermissionsEnum.VIEW_BILLING}>
              <MenuItem
                onClick={() => {
                  this.props.onClickMenuItem(() => this.props.navigate('/billing'));
                }}
                data-qa="qa-billing-button"
              >
                <ListItemIcon>
                  <BillingIcon />
                </ListItemIcon>
                <ListItemText> Billing </ListItemText>
              </MenuItem>
              <Divider />
            </PermissionsCheck>
            <PermissionsCheck permission={PermissionsEnum.VIEW_MANUFACTURING_DASHBOARD}>
              <MenuItem
                onClick={() => {
                  this.props.onClickMenuItem(() => this.props.navigate('/manufacturingDashboard'));
                }}
                data-qa="qa-manufacturingDashboard-button"
              >
                <ListItemIcon>
                  <DashboardIcon />
                </ListItemIcon>
                <ListItemText> Manufacturing dashboard </ListItemText>
              </MenuItem>
              <Divider />
            </PermissionsCheck>
            <PermissionsCheck permission={PermissionsEnum.VIEW_FLEETS}>
              <MenuItem
                onClick={() => {
                  this.props.onClickMenuItem(() => this.props.navigate('/fleets'));
                }}
                data-qa="qa-fleets-list-item"
              >
                <ListItemIcon>
                  <FleetIcon />
                </ListItemIcon>
                <ListItemText> Fleets </ListItemText>
              </MenuItem>
              <Divider />
            </PermissionsCheck>
            <PermissionsCheck
              permission={[PermissionsEnum.RECEIVE_FILES, PermissionsEnum.SEND_FILES]}
            >
              <MenuItem
                onClick={() => {
                  this.props.onClickMenuItem(() => this.props.navigate('/file-management'));
                }}
                data-qa="qa-file-management-list-item"
              >
                <ListItemIcon>
                  <FolderIcon />
                </ListItemIcon>
                <ListItemText> File management </ListItemText>
              </MenuItem>
              <Divider />
            </PermissionsCheck>
            <PermissionsCheck permission={PermissionsEnum.VIEW_UPDATE_MANAGEMENT}>
              <MenuItem onClick={this.props.onToggleUpdateMenu} data-qa="qa-toggleupdatemenu">
                <ListItemIcon>
                  <UpdateManagementIcon />
                </ListItemIcon>
                <ListItemText> Update management </ListItemText>
                {this.props.openUpdateMenu ? <ExpandLess /> : <ExpandMore />}
              </MenuItem>
              <Collapse in={this.props.openUpdateMenu} timeout="auto" unmountOnExit>
                <List
                  component="div"
                  style={{
                    paddingLeft: '20px',
                  }}
                >
                  <ListItem
                    button
                    onClick={() => {
                      this.props.onClickMenuItem(() => this.props.navigate('/update-packages'));
                    }}
                    data-qa="qa-packages"
                  >
                    <ListItemIcon>
                      <UpdatePackageIcon />
                    </ListItemIcon>
                    <ListItemText> Packages </ListItemText>
                  </ListItem>
                  <PermissionsCheck permission={PermissionsEnum.VIEW_UPDATE_JOBS}>
                    <ListItem
                      button
                      onClick={() => {
                        this.props.onClickMenuItem(() => this.props.navigate('/update-jobs'));
                      }}
                      data-qa="qa-update-jobs"
                    >
                      <ListItemIcon>
                        <UpdateJobIcon />
                      </ListItemIcon>
                      <ListItemText> Update jobs </ListItemText>
                    </ListItem>
                  </PermissionsCheck>
                  <PermissionsCheck permission={PermissionsEnum.VIEW_COMMAND_JOBS}>
                    <ListItem
                      button
                      onClick={() => {
                        this.props.onClickMenuItem(() => this.props.navigate('/command-jobs'));
                      }}
                      data-qa="qa-command-jobs"
                    >
                      <ListItemIcon>
                        <UpdateJobIcon />
                      </ListItemIcon>
                      <ListItemText> Command jobs </ListItemText>
                    </ListItem>
                  </PermissionsCheck>
                </List>
              </Collapse>
              <Divider />
            </PermissionsCheck>
            <PermissionsCheck permission={PermissionsEnum.VIEW_CHAT}>
              <MenuItem
                onClick={() => {
                  this.props.onClickMenuItem(() => this.props.navigate('/chat-management'));
                }}
                data-qa="qa-chat-management"
              >
                <ListItemIcon>
                  <FolderIcon />
                </ListItemIcon>
                <ListItemText> Chat Management </ListItemText>
              </MenuItem>
            </PermissionsCheck>
            <Divider />
            <MenuItem onClick={this.props.onToggleAdminMenu} data-qa="qa-administration-button">
              <ListItemIcon>
                <BuildIcon />
              </ListItemIcon>
              <ListItemText> Administration </ListItemText>
              {this.props.openAdminMenu ? <ExpandLess /> : <ExpandMore />}
            </MenuItem>
            <Collapse in={this.props.openAdminMenu} timeout="auto" unmountOnExit>
              <List
                component="div"
                style={{
                  paddingLeft: '20px',
                }}
              >
                <PermissionsCheck permission={PermissionsEnum.VIEW_USERS}>
                  <ListItem
                    button
                    onClick={() => {
                      this.props.onClickMenuItem(() => this.props.navigate('/user-accounts'));
                    }}
                    data-qa="qa-user-accounts"
                  >
                    <ListItemIcon>
                      <PersonIcon />
                    </ListItemIcon>
                    <ListItemText> User accounts </ListItemText>
                  </ListItem>
                </PermissionsCheck>
                <PermissionsCheck permission={PermissionsEnum.VIEW_USER_AUDIT_LOGS}>
                  <ListItem
                    button
                    onClick={() => {
                      this.props.onClickMenuItem(() => this.props.navigate('/user-audit-logs'));
                    }}
                    data-qa="qa-user-audit-logs"
                  >
                    <ListItemIcon>
                      <FingerprintIcon />
                    </ListItemIcon>
                    <ListItemText> User audit logs </ListItemText>
                  </ListItem>
                </PermissionsCheck>
                <PermissionsCheck permission={PermissionsEnum.VIEW_REGIONS}>
                  <ListItem
                    button
                    onClick={() => {
                      this.props.onClickMenuItem(() => this.props.navigate('/regions-and-groups'));
                    }}
                    data-qa="qa-regions-and-groups"
                  >
                    <ListItemIcon>
                      <MapIcon />
                    </ListItemIcon>
                    <ListItemText> Regions and groups </ListItemText>
                  </ListItem>
                </PermissionsCheck>
                <PermissionsCheck permission={PermissionsEnum.VIEW_ALERTS}>
                  <ListItem
                    button
                    onClick={() => {
                      this.props.onClickMenuItem(() =>
                        this.props.navigate('/system-alert-configuration')
                      );
                    }}
                    data-qa="qa-system-alert-configuration"
                  >
                    <ListItemIcon>
                      <NotificationsIcon />
                    </ListItemIcon>
                    <ListItemText> System alert configuration </ListItemText>
                  </ListItem>
                </PermissionsCheck>
                <PermissionsCheck permission={PermissionsEnum.VIEW_ALERT_CONFIGURATION}>
                  <ListItem
                    button
                    onClick={() => {
                      this.props.onClickMenuItem(() =>
                        this.props.navigate('/status-alert-configuration')
                      );
                    }}
                    data-qa="qa-status-alert-configuration"
                  >
                    <ListItemIcon>
                      <NotificationsIcon />
                    </ListItemIcon>
                    <ListItemText> Status alert configuration </ListItemText>
                  </ListItem>
                </PermissionsCheck>
                <ListItem
                  button
                  onClick={() => {
                    this.props.onClickMenuItem(() => this.props.navigate('/user-settings'));
                  }}
                  data-qa="qa-user-settings"
                >
                  <ListItemIcon>
                    <PermContactIcon />
                  </ListItemIcon>
                  <ListItemText> User settings </ListItemText>
                </ListItem>
                <PermissionsCheck permission={PermissionsEnum.VIEW_SYSTEM_SETTINGS}>
                  <ListItem
                    button
                    onClick={() => {
                      this.props.onClickMenuItem(() => this.props.navigate('/system-settings'));
                    }}
                    data-qa="qa-system-settings"
                  >
                    <ListItemIcon>
                      <SettingsIcon />
                    </ListItemIcon>
                    <ListItemText> System settings </ListItemText>
                  </ListItem>
                </PermissionsCheck>
                <PermissionsCheck permission={PermissionsEnum.VIEW_PERMISSIONS}>
                  <ListItem
                    button
                    onClick={() => {
                      this.props.onClickMenuItem(() => this.props.navigate('/permissions'));
                    }}
                    data-qa="qa-permissions"
                  >
                    <ListItemIcon>
                      <CheckBoxIcon />
                    </ListItemIcon>
                    <ListItemText> Permissions </ListItemText>
                  </ListItem>
                </PermissionsCheck>
              </List>
            </Collapse>
            <Divider />
          </List>
        </Drawer>
      </div>
    );
  }
}

AppMenu.propTypes = {
  open: PropTypes.bool,
  onToggleMenu: PropTypes.func,
  onClickMenuItem: PropTypes.func,
  onRequestChange: PropTypes.func,
};

AppMenu.defaultProps = {
  open: false,
  onToggleMenu: () => {},
  onClickMenuItem: () => {},
  onRequestChange: () => {},
};

export default withRouter(AppMenu);
